// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__261sY","title":"AfterBackImages_title__1OA5_","images":"AfterBackImages_images__1YGN1"};